import { CreateCodeArguments } from '../../components/Homepage/CreateFlowcodeForm/CreateFlowcodeFormDesktop/CreateFlowcodeFormDesktop.hooks'
import { GENERATOR_FORM_CACHE_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { logger } from '@dtx-company/logger'
import { useMemo } from 'react'
import { v4 } from 'uuid'

export function useGeneratorCacheKey(): string {
  return useMemo(() => v4(), [])
}

export async function getGeneratorFormCache(
  cacheKey: string
): Promise<CreateCodeArguments | undefined> {
  try {
    const params = new URLSearchParams()
    params.append('cacheKey', cacheKey)
    const res = await fetch(`${GENERATOR_FORM_CACHE_ENDPOINT}?${params.toString()}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-type': 'application/json'
      }
    })
    if (res.ok) {
      const { value } = await res.json()
      return value as CreateCodeArguments
    }
    if (!res.ok) {
      await logger.logFetchError(res, { technicalArea: 'authentication' })
    }
    return undefined
  } catch (e) {
    logger.logError(e, { technicalArea: 'authentication' })
  }
}

export async function clearGeneratorFormCache(cacheKey: string): Promise<boolean> {
  try {
    const params = new URLSearchParams()
    params.set('cacheKey', cacheKey)
    const res = await fetch(`${GENERATOR_FORM_CACHE_ENDPOINT}?${params.toString()}`, {
      method: 'DELETE',
      credentials: 'include'
    })

    if (!res.ok) {
      await logger.logFetchError(res, { technicalArea: 'authentication' })
    }

    return res.ok
  } catch (e) {
    logger.logError(e, { technicalArea: 'authentication' })
    return false
  }
}
